import global_axios from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion, existeSesion } from '../../funciones_globales/manejosesion';
import { LOAD_VALORESSESIONFORM, RESET_VALORESSESIONFORM } from './actionTypes';
import { detectarNavegador } from "../../funciones_globales/deteccionNavegador";

export const generar_LogAuditoriaIngresoForm = (codFormulario) => {

    let codEmpresa = JSON.parse(getItemDatosSesion('empresaActual')).Id;
    let usuario = getItemDatosSesion('usuario');
    let perfilId = JSON.parse(getItemDatosSesion('perfil')).Id;

    return (dispatch) => {
		return global_axios({
			url: '/logsauditoria',
            method: 'POST',
            data: { CodEmpresa: codEmpresa,
                    Usuario: usuario,
                    PerfilId: perfilId,
                    Navegador: detectarNavegador(),
                    CodFormulario: codFormulario,
                    TipoEvento: 'INGRESOFORM',
                    Observacion: 'INGRESO OK' }
        })
        .then( response => {
            let valoresSesionForm = response.data.valoresAcceso;
            dispatch({
				type: LOAD_VALORESSESIONFORM,
				data: valoresSesionForm
            });
        });
	}
}

export const generar_LogAuditoriaSalidaForm = (codFormulario) => {    
    let sesionActiva = existeSesion();
    const valoresSesionForm = { IdRegAudit: null, Formulario: null, Usuario: null, Permiso: null, FechaProceso: null,
        CambioFechaProceso: null, CantidadDias: null, Departamento: null};

    if (sesionActiva){        
        let codEmpresa = JSON.parse(getItemDatosSesion('empresaActual')).Id;
        let usuario = getItemDatosSesion('usuario');
        let perfilId = JSON.parse(getItemDatosSesion('perfil')).Id;

        return (dispatch) => {
            return global_axios({
                url: '/logsauditoria',
                method: 'POST',
                data: { CodEmpresa: codEmpresa,
                        Usuario: usuario,
                        PerfilId: perfilId,
                        Navegador: detectarNavegador(),
                        CodFormulario: codFormulario,
                        TipoEvento: 'SALIDAFORM',
                        Observacion: 'SALIDA OK' }
            })
            .then( response => {
                dispatch({
                    type: RESET_VALORESSESIONFORM,
                    data: valoresSesionForm
                });
            });
        }
    }else{
        return { type: RESET_VALORESSESIONFORM,
                 data: valoresSesionForm
        };
    }
}